import React from "react";
import Question from "./Question";
import { Link } from "gatsby";

function FAQ() {

  return (
    <div className="mt-12 mx-auto w-5/6 max-w-4xl">
      <h3 className="mb-12 text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">Frequently Asked Questions</h3>
      <hr className="border-b border-gray-100" />
      <Question 
        question="Why landing pages?"
        answer="Landing pages are the chocolate flavor of web projects. Most of us need them at some point and so I figured it was a good use case to focus on. I hope to expand soon though!"
      />         
      <Question 
        question="What tech stack do you use?"
        answer="My preferred front end tech stack is React/Gatsby with TailwindCSS for styling. The static site build makes them super fast. 
          I deploy the site on Netlify which has a great CDN network."
      />  
      <Question 
        question="Do you host the website?"
        answer="We can host it for a monthly fee or if you want to manage it yourself we will setup a Netlify account for your website and hand that over to you."
      />        
      <Question 
        question="How will you share the code with me?"
        answer="I will give you access to a Github Repository which has the code."
      />  
      <Question 
        question="Can I get some tweaks with the basic package?"
        answer="We can discuss it but generally that will be a custom build. I offer an opinionated solution because it allows me to keep my costs low which I pass onto you 
          for a great deal. :)"
      />              
      <Question 
        question="Why are you asking me to fill out this questionaire and come up with benefits and stuff?"
        answer="I'm not trying to replace a whole design + dev team. If you have the bugdet by all means go hire them. I'm trying to provide a low cost solution
          and I do this by working with you in a streamlined fashion."
      />    
      <Question 
        question="What if I want something custom made?"
        answer={<p>I am happy to look into a custom made project for you! Please send me a <Link className="text-indigo-600 font-medium" to="/contact">message</Link> and we'll talk. :)</p>}
      />                          
    </div>
  )
}

export default FAQ;